import { API_BASE } from '../config/env';
import { httpConstants } from '../constants';
import { IdeationDataType } from '../features/NewIdeationXPLR/IdeationXPLR';
import { fieldAPIKeyMap } from '../features/NewIdeationXPLR/NewIdeation/constants';
import { httpService } from '../utility/httpService';

export const fetchIdeationData = async (
  page: number,
  size: number = 25,
  sortBy: string,
  status: string
) => {
  const updatedStatus = status === 'all' || status === undefined ? '' : status;
  const organizationId = localStorage.getItem('current_organization') || '';
  const url = `${API_BASE}/api/v1/ideation/use-cases/by-organization/?organization_id=${organizationId}&page=${page}&size=${size}&sortBy=${sortBy}${!!updatedStatus ? `&status=${updatedStatus}` : ''}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response as { data: any; pagination: any };
};

export const fetchIdeationStatus = async (useCaseId: string) => {
  const organizationId = localStorage.getItem('current_organization') || '';
  const url = `${API_BASE}/api/v1/ideation/status/?organization_id=${organizationId}&use_case_id=${useCaseId}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response as IdeationDataType;
};

export const getIdeationStatisticsTotal = async (organizationId: string) => {
  const url = `${API_BASE}/api/v1/ideation/statistics/total/?organization_id=${organizationId}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response;
};

export const getIdeationStatisticsDomainAndFunction = async (
  organizationId: string,
  domain?: string,
  status?: string
) => {
  const url = `${API_BASE}/api/v1/ideation/statistics/?organization_id=${organizationId}${!!domain ? `&domain=${domain}` : ''}${!!status ? `&status=${status}` : ''}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response;
};

export const getTableData = async (
  organizationId: string,
  page: number,
  size: number,
  status?: string,
  domain?: string,
  functionType?: string,
  impact?: string
) => {
  const url = `${API_BASE}/api/v1/ideation/use-cases/by-organization/?organization_id=${organizationId}&page=${page}&size=${size}&status=${status === 'all' || status === undefined ? '' : status}&domain=${domain === 'all' || domain === undefined ? '' : domain}&function=${functionType === 'All Functions' || functionType === undefined ? '' : functionType.replace('&', '%26')}&impact=${impact === 'all' || impact === undefined ? '' : impact}&`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response;
};

export const deleteTableUsecase = async (id: string) => {
  const url = `${API_BASE}/api/v1/ideation/use-cases/${id}/soft_delete/`;
  const response = await httpService(httpConstants.METHOD_TYPE.DELETE, url);
  return response;
};

export const deleteTableNewAiOpportunity = async (id: string) => {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/new_ai_opportunity/${id}/`;
  const response = await httpService(httpConstants.METHOD_TYPE.DELETE, url);
  return response;
};

export const getOpportunityData = async (
  organizationId: string,
  page: number,
  size: number,
  searchTerm?: string,
  functionName?: string,
  impact?: string,
  status?: string
): Promise<{ data: any; pagination: any }> => {
  const url = `${API_BASE}/api/v1/ideation/use-cases/ai-opportunities-by-organization/?organization_id=${organizationId}&page=${page}&size=${size}${!searchTerm ? '' : `&opportunityName_Icontains=${searchTerm}`}${!functionName ? '' : `&function=${encodeURIComponent(functionName)}`}${!impact ? '' : `&impact=${impact}`}${!status ? '' : `&status=${status}`}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response as { data: any; pagination: any  };
};

export const getOpportunityDetails = async (
  organizationId: string,
  diagramId: string,
  id: number
) => {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/opportunities/with-agent-enablement/${id}/?diagram_id=${diagramId}&organization_id=${organizationId}`;
  const response = await httpService(httpConstants.METHOD_TYPE.GET, url);
  return response;
};

export const apiUpdateOpportunityDetails = async (id: number, payload: any) => {
  const url = `${API_BASE}/api/v1/e2e_taxonomy/opportunities/${id}/`;
  const response = await httpService(httpConstants.METHOD_TYPE.PATCH, url, payload);
  return response;
};

export const deleteQueryHistory = async (chatId: string, fieldType: string) => {
  try {
    const organizationId = localStorage.getItem('current_organization') || '';
    const url = `${API_BASE}/api/v1/ideation/query-history/${chatId}/delete/`;
    const response = await httpService(httpConstants.METHOD_TYPE.DELETE, url, {
      organization_id: organizationId,
      field_type: fieldAPIKeyMap[fieldType],
    });
    return response;
  } catch (error) {
    console.error('Failed to delete query history:', error);
    throw error;
  }
};
